import { takeLatest, put } from 'redux-saga/effects';

import VideoService from '../../../services/VideoService';
import {
  getVideoFail,
  getVideoRequest,
  getVideoSuccess,
  getVideoListFail,
  getVideoListRequest,
  getVideoListSuccess,
  saveVideoFail,
  saveVideoRequest,
  saveVideoSuccess,
  createVideoRequest,
  createVideoSuccess,
  createVideoFail,
  deleteVideoRequest,
  deleteVideoSuccess,
  deleteVideoFail,
  setVideoListDirty,
  initVideoRequest,
  initVideoSuccess,
  initVideoFail,
  clearVideoList,
} from './actions';
import { logOut } from '../auth/actions';
import { apiCall } from '../../effects';
import { getErrorNotification } from "../../util";
import { notify } from '../notifications/actions';

function* getVideoList({ payload }: ReturnType<typeof getVideoListRequest>) {
  try {
    const list = yield apiCall(VideoService.list, payload);
    yield put(getVideoListSuccess(list));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getVideoListFail());
  }
}

function* getVideo({ payload }: ReturnType<typeof getVideoRequest>) {
  try {
    const response = yield apiCall(VideoService.get, payload);
    yield put(getVideoSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(getVideoFail());
  }
}

function* saveVideo({ payload }: ReturnType<typeof saveVideoRequest>) {
  try {
    const response = yield apiCall(VideoService.save, payload.id, payload);
    yield put(saveVideoSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(saveVideoFail());
  }
}

function* createVideo({ payload }: ReturnType<typeof createVideoRequest>) {
  try {
    const response = yield apiCall(VideoService.create, payload);
    yield put(createVideoSuccess(response));
  } catch (e) {
    yield put(initVideoSuccess(payload));
    yield put(notify(getErrorNotification(e)));
    yield put(createVideoFail());
  }
}

function* deleteVideo({ payload }: ReturnType<typeof deleteVideoRequest>) {
  try {
    yield apiCall(VideoService.delete, payload);
    yield put(deleteVideoSuccess());
    yield put(setVideoListDirty(true));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(deleteVideoFail());
  }
}

function* getTemplateVideo(){
  try {
    const response = yield apiCall(VideoService.template);
    yield put(initVideoSuccess(response));
  } catch (e) {
    yield put(notify(getErrorNotification(e)));
    yield put(initVideoFail());
  }
}

function* clearList() {
  yield put(clearVideoList());
}

export default [
  takeLatest(getVideoListRequest.type, getVideoList),
  takeLatest(getVideoRequest.type, getVideo),
  takeLatest(saveVideoRequest.type, saveVideo),
  takeLatest(createVideoRequest.type, createVideo),
  takeLatest(deleteVideoRequest.type, deleteVideo),
  takeLatest(initVideoRequest.type, getTemplateVideo),
  takeLatest(logOut.type, clearList),
];
